module.exports = __webpack_public_path__ + "img/elha-logo-white.53dcda6f.svg";